import { AI_SUGGESTION_TRIGGERED_FROM } from '@atlaskit/editor-common/analytics';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { keydownHandler } from '@atlaskit/editor-prosemirror/keymap';
import { clearSuggestion, updateLocale } from './commands/commands';
import { suggestionManager } from './handlers/suggestion-manager';
import { inlineSuggestionPluginKey } from './inline-suggestion-plugin-key';
import { createInitialState, createPluginState, getPluginState as getInlineSuggestionState } from './plugin-factory';
import { createKeyHander, docHasChanged, fireAnalyticsForNewInlineSuggestionShown, localeHasChanged, KeydownActionType, hasActiveSuggestion, isFocusTransitioningToPopup, shouldInterceptRightArrowAtDocEnd } from './utils';
export var createInlineSuggestionPlugin = function createInlineSuggestionPlugin(options) {
  var dispatch = options.dispatch,
    getIntl = options.getIntl,
    api = options.api;
  var _getIntl = getIntl(),
    locale = _getIntl.locale;
  return new SafePlugin({
    key: inlineSuggestionPluginKey,
    state: createPluginState(dispatch, createInitialState({
      locale: locale
    })),
    props: {
      decorations: function decorations(state) {
        var _getInlineSuggestionS = getInlineSuggestionState(state),
          decorationSet = _getInlineSuggestionS.decorationSet;
        return decorationSet;
      },
      handleKeyDown: keydownHandler({
        Enter: createKeyHander(KeydownActionType.INSERT, AI_SUGGESTION_TRIGGERED_FROM.ENTER_BUTTON, api),
        Tab: createKeyHander(KeydownActionType.INSERT, AI_SUGGESTION_TRIGGERED_FROM.TAB_BUTTON, api),
        Escape: createKeyHander(KeydownActionType.DISMISS, AI_SUGGESTION_TRIGGERED_FROM.ESCAPE_BUTTON, api),
        ArrowRight: shouldInterceptRightArrowAtDocEnd
      }),
      handleDOMEvents: {
        blur: function blur(view, event) {
          if (hasActiveSuggestion(view.state) && !isFocusTransitioningToPopup(event)) {
            clearSuggestion()(view.state, view.dispatch);
            return false;
          }
        }
      }
    },
    view: function view() {
      return {
        update: function update(view, prevState) {
          var currentState = view.state;
          if (docHasChanged(prevState, currentState)) {
            suggestionManager.scheduleScanForSuggestions(view);
          }
          var currentLocale = getIntl().locale;
          if (localeHasChanged(currentState, currentLocale)) {
            updateLocale(currentLocale)(currentState, view.dispatch);
          }
        },
        destroy: function destroy() {
          suggestionManager.cancelSuggestionScans();
        }
      };
    },
    appendTransaction: function appendTransaction(_transactions, oldState, newState) {
      return fireAnalyticsForNewInlineSuggestionShown(oldState, newState, api);
    }
  });
};